module.exports = __webpack_public_path__ + "static/media/krx-derivatives-tutorial.5d70a72f.jpg";